import { InfoOutlined } from "@mui/icons-material";
import { ClickAwayListener, Tooltip } from "@mui/material";
import { useState } from "react";

import HNSColors from "../../../../../../../ui library/HNSColors";

const ReportTooltip = ({
  description,
  allowHover = false,
  arrowPlacement = "right",
  customContent = null,
  sxContainer = {},
}) => {
  const [openTooltip, setOpenTooltip] = useState(false);

  function handleTooltipClose() {
    setOpenTooltip(false);
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div style={sxContainer} className="flex flex-wrap items-center justify-center">
        <Tooltip
          onClose={handleTooltipClose}
          onOpen={allowHover ? () => setOpenTooltip(true) : undefined}
          open={openTooltip}
          disableFocusListener
          disableHoverListener={!allowHover}
          disableTouchListener
          title={description || "No description available."}
          placement={arrowPlacement}
          arrow
          slotProps={{
            popper: {
              disablePortal: true,
            },
            tooltip: {
              sx: {
                backgroundColor: HNSColors.tertiary[975],
                boxShadow: "0px 3px 16px 0px #B8D2E6",
                fontSize: "14px",
                fontWeight: 400,
                color: HNSColors.neutrals[100],
              },
            },
            arrow: {
              sx: {
                color: HNSColors.tertiary[975],
              },
            },
          }}
        >
          {customContent ? (
            customContent
          ) : (
            <InfoOutlined
              onClick={allowHover ? undefined : () => setOpenTooltip(!openTooltip)}
              sx={{ color: HNSColors.primary[500], fontSize: "20px", cursor: "pointer" }}
            />
          )}
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default ReportTooltip;
